import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[hsl(var(--background))]">
      <div className="w-full max-w-sm space-y-6 fade-up">
        <img src="/logo-kgd.jpeg" alt="KORIS Gaming Distribution" className="h-20 object-contain -ml-2" />
        {children}
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary" data-testid="back-to-login-link"><ArrowLeft className="h-4 w-4" />Retour à la connexion</Link>
      </div>
    </div>
  );
}

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      setMsg((await api.post("/auth/forgot-password", { email })).data.message);
    } catch (er) {
      setError(errMsg(er));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell>
      <div>
        <h2 className="text-2xl font-extrabold tracking-tight">Mot de passe oublié</h2>
        <p className="text-sm text-muted-foreground mt-1">Saisissez l'adresse e-mail de votre compte : vous recevrez un lien valable 30 minutes.</p>
      </div>
      {msg ? (
        <div className="text-sm bg-emerald-50 border border-emerald-200 text-emerald-900 rounded p-3" data-testid="forgot-success">{msg}</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11" data-testid="forgot-email-input" /></div>
          {error && <div className="text-sm text-primary bg-red-50 border border-red-200 rounded p-2.5" data-testid="forgot-error">{error}</div>}
          <Button type="submit" className="w-full h-11" disabled={busy} data-testid="forgot-submit-button"><Mail className="h-4 w-4 mr-2" />{busy ? "Envoi…" : "Envoyer le lien"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
